function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * @class Oskari.mapframework.request.common.MapMoveRequest
 *
 * Requests for the map to move to given location and zoom level/bounds.
 * Map sends out Oskari.mapframework.event.common.AfterMapMoveEvent after it has
 * processed the request and the map has been moved.
 *
 * Requests are build and sent through Oskari.Sandbox.
 * Oskari.mapframework.request.Request superclass documents how to send one.
 */
Oskari.clazz.define('Oskari.mapframework.request.common.MapMoveRequest',
/**
 * @static @method create called automatically on construction
 *
 *
 * @param {Number} centerX
 *            longitude
 * @param {Number} centerY
 *            latitude
 * @param {Number/OpenLayers.Bounds/Object} zoom (optional)
 *            zoomlevel (0-12) or OpenLayers.Bounds to zoom to or an object with property scale { scale : 10000 }.
 *            If not given the map zoom level stays as it was.
 * @param {Object} options
 *          object with optional parameters srsName and animation.
 * @param {string} deprecatedSrsName
 *          used to be srsName but it is moved to options.
 */
function (centerX, centerY, zoom, options, deprecatedSrsName) {
  this._creator = null;
  this._centerX = centerX;
  this._centerY = centerY;
  this._zoom = zoom;
  // destruct options
  if (_typeof(options) !== 'object') {
    options = {};
  }
  this._projectionCode = options.srsName || deprecatedSrsName;
  this._animation = options.animation;
}, {
  /** @static @property {String} __name request name */
  __name: 'MapMoveRequest',
  /**
   * @method getName
   * @return {String} request name
   */
  getName: function getName() {
    return this.__name;
  },
  /**
   * @method getCenterX
   * @return {Number} longitude
   */
  getCenterX: function getCenterX() {
    return this._centerX;
  },
  /**
   * @method getCenterY
   * @return {Number} latitude
   */
  getCenterY: function getCenterY() {
    return this._centerY;
  },
  /**
   * @method getZoom
   * @return {Number/OpenLayers.Bounds/Object} zoomlevel (0-12) or OpenLayers.Bounds or Object with scale property.
   * to zoom to
   */
  getZoom: function getZoom() {
    return this._zoom;
  },
  /**
   * @method getSrsName
   * @return {String} _projectionCode SRS projection code
   */
  getSrsName: function getSrsName() {
    return this._projectionCode;
  },
  /**
   * @method getAnimation
   * @return {String} animation to use on map move.
   */
  getAnimation: function getAnimation() {
    return this._animation;
  }
}, {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  'protocol': ['Oskari.mapframework.request.Request']
});